import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout, Result, Button } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';

const { Header, Content } = Layout;

const FormExpired = () => {
  const navigate = useNavigate();

  return (
    <Layout style={{ minHeight: '100vh', background: '#fafafa' }}>
      <Header style={{ 
        padding: '12px 16px', 
        background: '#fff', 
        borderBottom: '1px solid #f0f0f0',
        height: 'auto'
      }}>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'flex-end', 
          alignItems: 'center'
        }}>
          <img
            src="/images/FM_Logo.png"
            alt="Festivals Malta"
            onClick={() => navigate('/')}
            style={{
              height: '36px',
              width: 'auto',
              maxWidth: '160px',
              cursor: 'pointer',
              objectFit: 'contain',
            }}
          />
        </div>
      </Header>

      <Content style={{ 
        padding: '48px', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        minHeight: 'calc(100vh - 64px)'
      }}>
        <Result
          icon={<ClockCircleOutlined style={{ color: '#faad14' }} />}
          title="Call / Application Has Expired"
          subTitle="The application period for this call has ended and is no longer accepting submissions."
          extra={[
            <Button 
              type="primary" 
              key="home"
              onClick={() => navigate('/')}
              size="large"
              style={{
                background: '#FFAC00',
                borderColor: '#FFAC00',
                fontWeight: 500
              }}
            >
              Return to Home
            </Button>
          ]}
          style={{
            background: '#fff',
            padding: '48px 24px',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          }}
        />
      </Content>
    </Layout>
  );
};

export default FormExpired;
